import { Heading } from "@components/typography"
import { Container, FlexBox } from "@components/wrapper"
import { HARISENIN_PUBLIC_ICON } from "@constants/const/pictures"
import { BannerInfo } from "@interfaces/misc"
import clsx from "clsx"
import Image from "next/image"
import { FC } from "react"
import { BsCheckCircleFill } from "react-icons/bs"
import { WhyList } from "../const/why-list"

export const WhyUs: FC<{ info: BannerInfo | null }> = ({info}) => {
  return (
    <section className="bg-[#f9fafc] py-10 sm:py-15">
      <Container>
        <div className="mx-auto text-center sm:mb-8 mb-5">
          <Heading headingLevel="title" className="mb-2">
            Mengapa Memilih <span className="text-green">harisenin.com</span>
          </Heading>
          <Heading headingLevel="subtitle">Telah Dipercaya oleh {info?.total_alumni} Alumni</Heading>
        </div>

        <FlexBox className="sm-only:flex-col sm:gap-6 gap-5">
          {WhyList.map((value, index) => (
            <div key={index} className={clsx("sm:w-1/3 bg-white sm:p-6", "w-full p-5")}>
              <FlexBox
                className={clsx(
                  "rounded-full sm:p-2 sm:wh-16 bg-white-f9 sm:mb-5",
                  "w-[50px] h-[50px] p-1 mb-3"
                )}
              >
                <Image
                  src={`${HARISENIN_PUBLIC_ICON}${value.icon}`}
                  alt="icon corporate"
                  width={32}
                  height={32}
                  className="object-contain m-auto sm:wh-8 wh-6"
                />
              </FlexBox>

              <h3 className={clsx("font-semibold sm:text-xl sm:mb-6", "text-sm mb-3.5")}>
                {value.title}
              </h3>

              <FlexBox direction="col" className="gap-2.5">
                {value.list.map((v, i) => (
                  <FlexBox className="gap-3 sm-only:text-xs" key={i} align="center">
                    <BsCheckCircleFill color="blue" />
                    <span className="text-black-67">{v}</span>
                  </FlexBox>
                ))}
              </FlexBox>
            </div>
          ))}
        </FlexBox>
      </Container>
    </section>
  )
}
